import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Button, Spinner } from "react-bootstrap";
import { ErrorBoundary } from "react-error-boundary";
import { createUseStyles, useTheme } from "react-jss";
import { useIsMutating } from "react-query";
import { DayMonthFormat, PAGE_LENGTH, qnaStateTypes, todayText } from "../../../../../core";
import { BotContext } from "../../../../context";
import { ErrorFallback } from "../../../../molecule";
import { AnswerBubble } from "../AnswerBubble";
import { HistoryQA } from "../HistoryQA";
import Today from "../Today";
import { StartText } from "./StartText";
const useStyles = createUseStyles((theme) => ({
  loading: {
    height: "80vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  date: {
    textAlign: "center",
    margin: [12, 0],
    color: theme.dateColor,
    fontSize: theme.messageFontSize,
  },
  artak: {
    color: theme.automessageColor1,
    fontWeight: "bolder!important",
  },
  help: {
    color: theme.automessageColor2,
    fontWeight: "bolder",
  },
  moreButton: {
    background: `${theme.moreBtnBg}!important`,
    border: `${theme.moreBtnBg}!important`,
    direction: "rtl",
    fontSize: 10,
    height: 25,
    display: "flex!important",
    justifyContent: "center",
    alignItems: "center",
    margin: [15, "auto"],
  },
}));
const HistoryWithLogin = () => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const {
    chatStateMode,
    chats,
    selectedRoom,
    page,
    setPage,
    chatsArray,
    historyUser,
    rooms,
    showWelcome
  } = useContext(BotContext);
  const middlechatref = useRef(null);
  const [showMore, setShowMore] = useState(undefined);
  const lastChatRef = useRef(null);
  const loadmoreRef = useRef(null);
  const isMutatingPosts = useIsMutating(["getChatHistory"]);
  const isMutatingOthers = useIsMutating(["getOthersChats"]);
  const isMutatingRooms = useIsMutating(["getChatRooms"]);
  useEffect(() => {
    if (!historyUser) {
      if (isMutatingPosts === 0) {
        middlechatref?.current?.scrollIntoView();
      } else {
        loadmoreRef?.current?.scrollIntoView();
      }
    }
  }, [isMutatingPosts]);

  useEffect(() => {
    if (!!historyUser) {
      if (isMutatingOthers === 0) {
        middlechatref?.current?.scrollIntoView();
      } else {
        loadmoreRef?.current?.scrollIntoView();
      }
    }
  }, [isMutatingOthers]);
  useEffect(() => {
    const scrollHandler = (_) => {
      if (
        document.getElementById("header")?.getBoundingClientRect().top -
        loadmoreRef?.current?.getBoundingClientRect().top <
        -50
      ) {
        handleLoadMore();
      }
    };
    window.addEventListener("scroll", scrollHandler, true);
    return () => {
      window.removeEventListener("scroll", scrollHandler, true);
    };
  }, [chats]);
  useEffect(() => {
    if (chatsArray?.length % 50 === 0) {
      setShowMore(true);
    } else {
      setShowMore(false);
    }
  }, [chatsArray]);

  const handleLoadMore = () => {
    if (chatsArray.length >= page * PAGE_LENGTH) {
      setPage(page + 1);
    }
  };

  let n = 0;
  return (
    <>
      {!chats ? (
        !selectedRoom &&
          (!rooms || rooms?.length === 0) &&
          isMutatingRooms === 0 ? (
          <>
            <Today />
            <AnswerBubble
              message={{
                status: "True",
                text: "اتاقی وجود ندارد",
              }}
            />
          </>
        ) : chatsArray === undefined ? (
          isMutatingPosts !== 0 || isMutatingRooms !== 0 ? (
            <div className={styles.loading}>
              <Spinner animation="border" />
            </div>
          ) : (
            <>
              {/* <Today />

          <AnswerBubble
            message={{
              status: "True",
              text: "خطا در دریافت اطلاعات",
            }}
          /> */}
            </>
          )
        ) : (
          isMutatingPosts === 0 && (
            <>
              <Today />

              <AnswerBubble
                message={{
                  status: "True",
                  text: <StartText />,
                }}
              />
            </>
          )
        )
      ) : (
        <div ref={loadmoreRef} id="xx">
          {showMore && (
            <Button onClick={handleLoadMore} className={styles.moreButton}>
              در حال بارگذاری . . .
            </Button>
          )}
          {Object.keys(chats).map((date, gIndex) => {
            return (
              <ErrorBoundary FallbackComponent={ErrorFallback} key={gIndex}>
                <p className={styles.date}>
                  {todayText(date) ?? DayMonthFormat(date)}
                </p>
                {chats[date].map((QA, index) => {
                  n++;
                  return (
                    <Fragment key={index}>
                      <HistoryQA key={index} {...{ QA }} />
                      {/* change to this code for scrolling of last page to correct position */}
                      {n ===
                        PAGE_LENGTH -
                        (page * PAGE_LENGTH - chatsArray.length) -
                        1 && <div ref={middlechatref}></div>}
                      {n === chatsArray.length && <div ref={lastChatRef}></div>}
                    </Fragment>
                  );
                })}
              </ErrorBoundary>
            );
          })}
          <Today {...{ chats }} />
          {showWelcome && (
            <AnswerBubble
              message={{
                status: "True",
                text: <StartText />,
              }}
            />
          )}
        </div>
      )}
    </>
  );
};

export { HistoryWithLogin };
